import React from 'react'
import { ArrowCircleRight } from '@mui/icons-material';
import { title } from '../config/Config';
import shape_1 from "../Assets/images/shape_1.png";
import shape_2 from "../Assets/images/shape_2.svg";
import shape_3 from "../Assets/images/shape_3.png";
import shape_4 from "../Assets/images/shape_4.svg";



const EmailHosting = () => {
    return (
        <>
            <div className="email_hostingpage">
                <div className="email_baner">
                    <div className="container-layout">
                        <div className="row email_row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h1 className='text-center'>Bulk SMS & Email Hosting</h1>
                                <p className='text-center'>
                                    Bulk SMS and email hosting are services that allow businesses and individuals to send a large number of text messages (SMS) or emails to a group of recipients simultaneously. These services are commonly used for marketing, communication, and information dissemination purposes.
                                </p>

                                <p className='text-center'>Share processes and data securely on a need to know basis without the need for reconciliation it combines a permissione.</p>

                                {/* 
                                <ul className="breadcrumb mt-4">
                                    <li><a href="/">Home</a></li>
                                    <li>Bulk SMS & Email Hosting</li>
                                </ul> */}
                            </div>

                            {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div className="right_img">
                                    <img src={email_bg} alt='service_baner' />
                                </div>

                            </div> */}
                        </div>
                    </div>

                    <div className="shape-1">
                     <img src={shape_1} alt='shape_1'/>
                    </div>

                    <div className="shape-2">
                    <img src={shape_2} alt='shape_2'/>
                    </div>

                    <div className="shape-3">
                    <img src={shape_3} alt='shape_3'/>
                    </div>

                    <div className="shape-4">
                    <img src={shape_4} alt='shape_4'/>
                    </div>

                </div>

                <div className="email_widthsec">
                    <div className="detail_sec">
                        <div className="container-layout">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-xl-12">
                                    <p className='text-center primary_text'>BEST BULK SMS & EMAIL HOSTING SERVICES IN {title}</p>
                                    <h2 className='text-center'><span>Bulk SMS & Email Hosting</span></h2>

                                    <p className='text-center mt-4'>
                                        We are a leading bulk email service provider in Abohar offering high-quality bulk SMS services at an affordable price range. With our email hosting services, different types of brands and businesses can get help and support to communicate with their customers in an effective and simple manner. This way, these businesses can grow their sales or create more traffic to online portals or websites.
                                    </p>

                                    <p className='text-center'>
                                        Of course, bulk email and SMS is one of the most popular and preferred sources of online marketing. The major reason is that this is the method, by which you can create the highest ROI as compared to other digital marketing channels.
                                    </p>
                                </div>

                                {/* <div className="col-md-12 col-lg-6 col-xl-6">
                                    <img src={Bulk_sms} alt='Bulk_sms' className='right_email'/>
                                </div> */}
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12 col-lg-12 col-xl-12">
                                    <h3 className='text-center'>What do we provide?</h3>
                                </div>

                                <div className="col-md-12 col-lg-6 col-xl-6 mt-4">
                                    <div className="bg_ul">
                                        <p>When it comes to our expert and reliable email marketing services, we have the following things to offer</p>

                                        <ul>
                                            <li><ArrowCircleRight /><span>Transactional email</span></li>
                                            <li><ArrowCircleRight /><span>Promotional email</span></li>
                                            <li><ArrowCircleRight /><span>Bulk Email Reseller Program</span></li>
                                            <li><ArrowCircleRight /><span>KDedicated SMTP Server Program</span></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-md-12 col-lg-6 col-xl-6 mt-4">
                                    <div className="bg_ul">
                                        <p>If we talk about the bulk emailing, then it can help you to interact with customers by using newsletters regarding anything.</p>

                                        <ul>
                                            <li><ArrowCircleRight /><span>Email open reporting</span></li>
                                            <li><ArrowCircleRight /><span>Spam checking (free)</span></li>
                                            <li><ArrowCircleRight /><span>Automatic bounce handling</span></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-md-12 col-lg-12 col-xl-12 pt-5">
                                    <p>
                                        Hence, if you are willing to make the use of our reputed Bulk SMS and Email hosting solutions that are handled by talented personnel, then you should come to us and tell your requirements. We are genuinely available to help you with our cheaper Bulk email and SMS hosting services.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>

            </div>
        </>
    )
}

export default EmailHosting